import React, { createRef, useState, useEffect } from "react";

function MasterProfile(props) {


  return (
    <div style={{textAlign: 'center'}}>
        Master Profile
    </div>
  )


}

export default MasterProfile
